module.exports = __webpack_public_path__ + "c43bdcf0c5b1c32c93d0df5141fe7c3a.svg";